<template>
  <div>
    <v-btn :color="ui.btnColor"
    flat dark @click="openDialog()">
      <v-icon left :color="buttonColor.icon">
        {{data.icon}}
      </v-icon>
      <span :class="buttonColor.title">
        {{data.title}}
      </span>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor">
              dashboard_customize
            </v-icon>
            <span :class="ui.textHeadline">
              Licence and Subscriptions
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="mb-2">
            <v-btn outline :color="ui.btnColor" v-if="licenceOK">
              Licence: {{this.getUser.basic.rlic}}
            </v-btn>
            <v-btn outline :color="ui.colorError" v-else>
              Licence Limit Reached: {{this.getUser.basic.rlic}}
            </v-btn>
            <v-btn icon :color="ui.bkgdColor"
            v-if="!licenceOKCompanyNew || !licenceOKCompanyAccess">
              <v-icon :color="ui.colorWarning">account_balance</v-icon>
            </v-btn>
            <v-btn icon :color="ui.bkgdColor"
            v-if="!licenceOKFacilityNew || !licenceOKFacilityAccess">
              <v-icon :color="ui.colorWarning">place</v-icon>
            </v-btn>
            <v-spacer/>
            <v-btn :color="ui.btnColorError" flat dark v-if="!this.userOK">
              <v-icon left>
                person
              </v-icon>
              User
            </v-btn>
          </v-layout>
          <v-layout class="mb-2" v-if="dateExpired(this.getUserStats.dexp)">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon :color="ui.colorError">today</v-icon>
              </v-avatar>
              <span :class="ui.textSubheadingBoldError">
                Licence Expired: {{dateTypeA(this.getUserStats.dexp)}}
              </span>
            </v-chip>
          </v-layout>
          <v-layout class="mb-2" v-else>
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
              <v-avatar>
                <v-icon>today</v-icon>
              </v-avatar>
              Licence Expiry Date: {{dateTypeA(this.getUserStats.dexp)}}
            </v-chip>
          </v-layout>
          <v-layout class="mb-2">
            <v-chip :color="ui.bkgdColor" >
              <v-avatar>
                <v-icon :color="infoTermsOfUse.color">
                  {{infoTermsOfUse.icon}}
                </v-icon>
              </v-avatar>
              <span :class="infoTermsOfUse.colorText">
                {{infoTermsOfUse.title}}
              </span>
            </v-chip>
          </v-layout>
          <v-layout class="mb-2">
            <v-chip :color="ui.bkgdColor" >
              <v-avatar>
                <v-icon :color="infoDataPrivacy.color">
                  {{infoDataPrivacy.icon}}
                </v-icon>
              </v-avatar>
              <span :class="infoDataPrivacy.colorText">
                {{infoDataPrivacy.title}}
              </span>
            </v-chip>
          </v-layout>
          <v-layout class="mb-4 ml-0" v-if="this.getUserStats.act === false">
            <v-chip :color="ui.bkgdColor" >
              <v-avatar>
                <v-icon :color="ui.btnColorError">
                  person
                </v-icon>
              </v-avatar>
              <span :class="ui.textSubheadingBoldError">
                User is not Active.
              </span>
            </v-chip>
          </v-layout>
          <v-layout row class="text-xs-center">
            <v-flex xs3 offset-xs3>
              <span :class="ui.textSubheadingBold">
                Current
              </span>
            </v-flex>
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Free
              </span>
            </v-flex>
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Unlimited
              </span>
            </v-flex>
          </v-layout>
          <v-layout row class="text-xs-center mt-2">
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Company
              </span>
            </v-flex>
            <v-flex xs3>
              {{stats.nc1}} / {{stats.nc1a}}
            </v-flex>
            <v-flex xs3>
              {{this.getLicence.freeCompanyCreate}} / {{this.getLicence.freeCompanyAccess}}
            </v-flex>
            <v-flex xs3>
              Unlimited
            </v-flex>
          </v-layout>
          <v-layout row class="text-xs-center">
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Facility
              </span>
            </v-flex>
            <v-flex xs3>
              {{stats.nf1}} / {{stats.nf1a}}
            </v-flex>
            <v-flex xs3>
              {{this.getLicence.freeFacilityCreate}} / {{this.getLicence.freeFacilityAccess}}
            </v-flex>
            <v-flex xs3>
              Unlimited
            </v-flex>
          </v-layout>
          <v-layout row class="text-xs-center">
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Updates
              </span>
            </v-flex>
            <v-flex xs3>
              {{stats.n}}
            </v-flex>
            <v-flex xs3>
              {{this.getLicence.freeUpdates}}
            </v-flex>
            <v-flex xs3>
              Defined
            </v-flex>
          </v-layout>
          <v-layout row class="text-xs-center">
            <v-flex xs3>
              <span :class="ui.textSubheadingBold">
                Search
              </span>
            </v-flex>
            <v-flex xs3 offset-xs3>
              {{this.getLicence.freeSearch}}
            </v-flex>
            <v-flex xs3>
              Defined
            </v-flex>
          </v-layout>
          <v-layout class="mt-4"/>
          <v-layout row :class="ui.textImage">
            <v-flex xs11 offset-xs1>
              {{note}}
            </v-flex>
          </v-layout>
          <v-layout class="mt-2"/>
          <v-layout row :class="ui.textImage">
            <v-flex xs11 offset-xs1>
              {{warning}}
            </v-flex>
          </v-layout>
          <v-layout row class="mt-4 mr-2">
            <v-spacer/>
            <PublicFooterCard :data="{bkgd: this.ui.bkgdColor}"/>
          </v-layout>
          <v-layout row class="mt-0 mr-2">
            <v-spacer/>
            <PublicSoftwareVersion :data="{bkgd: this.ui.bkgdColor}"/>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!this.enableUpgradeLicenceBtn"
          :color="ui.btnColor" flat>
            <v-icon left> upgrade </v-icon>
            Uprade
          </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";
import PublicSoftwareVersion from "@/public/components/PublicSoftwareVersion";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line
  mixins: [
    dateFunctions,
    licenceFunctions,
    docRevsModFunctions,
    adminFunctions,
    apptheme
  ],
  components: {
    PublicFooterCard,
    PublicSoftwareVersion
  },
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: true,
      disableAddBtn: true,
      disableRemoveBtn: true,
      // eslint-disable-next-line
      note: "Note: Create / Access notation. Example 2 / 5, max 2 create and 5 access options per data object.",
      // eslint-disable-next-line
      warning: "User restrictions will apply when licence subscription limit is reached.",
      indeterminateProgressBar: false
    };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "getUserStats",
      "getCurrentPage",
      "getTermsAndConditions",
      "getDataPrivacy",
      "getLicence"
    ]),
    stats() {
      return this.getUserStats;
    },
    enableUpgradeLicenceBtn() {
      return false;
    },
    infoTermsOfUse() {
      let obj = {};
      obj.icon = "description";
      obj.policy = this.getTermsAndConditions.char.policy;
      obj.status = this.getTermsAndConditions.char.status;
      obj.rev = this.getTermsAndConditions.char.rev;
      obj.date = this.getTermsAndConditions.stats.date;
      obj.color = null;
      obj.colorText = null;
      if (obj.rev !== this.getUser.basic.rtc) {
        obj.color = this.ui.colorError;
        obj.colorText = this.ui.textSubheadingBoldError;
        obj.title = "Terms of Use (" + obj.rev + ") was not signed.";
      } else {
        obj.color = this.ui.btnColor;
        obj.colorText = this.ui.textSubheadingBold;
        obj.title = "Terms of Use (" + obj.rev + ") was signed.";
      }
      return obj;
    },
    infoDataPrivacy() {
      let obj = {};
      obj.icon = "admin_panel_settings";
      obj.policy = this.getDataPrivacy.char.policy;
      obj.status = this.getDataPrivacy.char.status;
      obj.rev = this.getDataPrivacy.char.rev;
      obj.date = this.getDataPrivacy.stats.date;
      obj.color = null;
      obj.colorText = null;
      if (obj.rev !== this.getUser.basic.rdp) {
        obj.color = this.ui.colorError;
        obj.colorText = this.ui.textSubheadingBoldError;
        obj.title = "Data Privacy (" + obj.rev + ") was not signed.";
        obj.title = "Data Privacy  (" + obj.rev + ") was not signed.";
      } else {
        obj.color = this.ui.btnColor;
        obj.colorText = this.ui.textSubheadingBold;
        obj.title = "Data Policy (" + obj.rev + ") was signed.";
      }
      return obj;
    },
    buttonColor() {
      let obj = {
        icon: "",
        title: ""
      };
      if (
        this.getTermsAndConditions.char.rev !== this.getUser.basic.rtc ||
        this.getDataPrivacy.char.rev !== this.getUser.basic.rdp ||
        !this.userOK ||
        !this.licenceOK
      ) {
        obj.icon = this.ui.colorError;
        obj.title = this.ui.textDescriptionError;
      } else if (!this.licenceOKCompanyNew) {
        obj.icon = this.ui.colorWarning;
        obj.title = this.ui.textDescriptionWarning;
      } else {
        obj.icon = this.data.colorIcon;
        obj.title = this.data.colorTitle;
      }
      return obj;
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    }
  }
};
</script>
